import { z } from 'zod'

/** One request-id rule for every mutation (D-14 / R-02). */
export const REQUEST_ID_PATTERN = /^[A-Za-z0-9._:-]{8,120}$/

export const REQUEST_ID_HEADER = 'X-Request-Id'
export const CSRF_HEADER = 'X-CSRF-Token'

export const requestIdSchema = z.string().regex(REQUEST_ID_PATTERN)

export function isValidRequestId(value: unknown): value is string {
  return typeof value === 'string' && REQUEST_ID_PATTERN.test(value)
}
